import { temAcesso } from '@/shared/auth/temAcesso'

const Requisicoes = () => import('./Requisicoes.vue')
const RequisicaoDetalhar = () => import('./RequisicaoDetalhar.vue')
const RequisicaoInserir = () => import('./RequisicaoInserir.vue')
const RequisicaoAtualizar = () => import('./RequisicaoAtualizar.vue')

export default {
    path: 'requisicoes',
    name: 'Contratos_Requisicoes',
    component: Requisicoes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CONT-REQ-00')) {
            next()
        }
    },
    children: [
        {
            path: 'inserir',
            name: 'Contratos_Requisicoes_Inserir',
            component: RequisicaoInserir,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REQ-01')) {
                    next()
                }
            }
        },
        {
            path: ':idRequisicao/detalhar',
            name: 'Contratos_Requisicoes_Detalhar',
            component: RequisicaoDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REQ-02')) {
                    next()
                }
            }
        },
        {
            path: ':idRequisicao/atualizar',
            name: 'Contratos_Requisicoes_Atualizar',
            component: RequisicaoAtualizar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REQ-03')) {
                    next()
                }
            }
        },
    ]
}
